
import { Option } from '../../types/user';
export const transformToDropdownOptions = (option: Option, includeNone = false) => {
    const options = Object.entries(option?.selections || {}).map(
      ([key, value]) => ({
        value: key,
        label: value
      })
    );
    
    return includeNone 
      ? [{ value: 'NONE', label: 'None' }, ...options]
      : options;
  };